/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { MED_DATE_ONLY_DISPLAY, formatDateTimeDisplay } from 'js/utils/DateTimeUtils';

import { Grid, Radio, Typography2 } from '@coursera/cds-core';

import type { AuthoringWidgetSummariesV1 } from 'bundles/widget-admin/types/WidgetTypes';

const styles = {
  root: css`
    .cds-checkboxAndRadio-labelText {
      max-width: 250px;
      display: inline-block !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &:hover {
      cursor: pointer;
    }
  `,
  date: css`
    padding: var(--cds-spacing-100) 0;
    padding-left: var(--cds-spacing-400);
  `,
};

type Props = {
  widget: AuthoringWidgetSummariesV1;
  onWidgetSelected: (id: string) => void;
};

const WidgetSelectionListItem = ({ widget, onWidgetSelected }: Props) => {
  return (
    <Grid container css={styles.root} onClick={() => onWidgetSelected(widget.id)}>
      <Grid item xs={8}>
        <Radio data-testid={widget.name} label={widget.name} value={widget.id} />
      </Grid>
      <Grid item xs={4}>
        <Typography2 component="p" variant="bodyPrimary" css={styles.date}>
          {formatDateTimeDisplay(widget.updatedAt, MED_DATE_ONLY_DISPLAY)}
        </Typography2>
      </Grid>
    </Grid>
  );
};

export default WidgetSelectionListItem;
